import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Nav from "./nav_manager";
import Footer from "../admin/footer";
import axios from 'axios';
import { useState, useEffect } from "react";


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));


export default function Dashboard() {

  const [list, setList] = useState([])
  const [selected, setSelected] = useState(null)
  const [agentList, setAgentList] = useState([])
  const [listold, setListold] = useState([])
  const [listoldStatus, setListoldStatus] = useState(false)

  useEffect(() => {
    const a = localStorage.getItem("Manager");
    if (a == null) {
      window.location.replace("/login")
    } else {


      getStatus()
      getInq(JSON.parse(a)[0].team);
      TeamList("Agent", JSON.parse(a)[0].team)

    }


  }, []);

  const TeamList = async (typ, id) => {
    const data = new FormData();
    data.append('team_id', id);
    data.append('type', typ);
    axios({
      method: 'post',
      url: '/api_lock/manager/team_agent.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (typ == "Agent") {

          setAgentList(Array.isArray(s.data) ? s.data : [])
        }

      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const getresponseCount = () => {
    return list.filter(item => item.manager_response == 0).length;
  }


  const getInq = async (id) => {
    const data = new FormData();
    data.append('team_id', id);

    axios({
      method: 'post',
      url: '/api_lock/manager/inq_get_for_manager_response.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        setList(Array.isArray(s.data) ? s.data : [])
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const getfilter_Agent = status => {
    const a = list;
    if (listoldStatus) {
      const newArray = a.filter(item => item.agent_name === status);
      setList(newArray)
    } else {
      setListold(a)
      setListoldStatus(true)
      const newArray = a.filter(item => item.agent_name === status);
      setList(newArray)
    }



  }


  const [status_list, setStatusList] = useState([])
  const getStatus = async () => {
    const data = new FormData();
    data.append('inquiry_id', '');

    axios({
      method: 'post',
      url: '/api_lock/status/list.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        setStatusList(Array.isArray(s.data) ? s.data : [])
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  // Function to get names by value
  const getNamesByValue = (array, value) => {
    return array
      .filter(item => item.value === value)
      .map(item => item.name);
  };



  return (
    <>

      <Nav />
      <div className="page-container" style={{ backgroundColor: "#F9FBFD" }}>
        {/* Content Wrapper START */}
        <div className="main-content">
          <h4>Manager Latest Inquiries Redial</h4>
          {/* start */}
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="m-b-0">Manager Redialed </p>
                      <h2 className="m-b-0">
                        <span>{list.length - getresponseCount()}</span>
                      </h2>
                    </div>
                    <div className="avatar avatar-icon avatar-lg avatar-blue">
                      <i className="anticon anticon-check"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="m-b-0">Manager Pending Redial</p>
                      <h2 className="m-b-0">
                        <span>{getresponseCount()}</span>
                      </h2>
                    </div>
                    <div className="avatar avatar-icon avatar-lg avatar-cyan">
                      <i className="anticon anticon-bar-chart" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="m-b-0">Total</p>
                      <h2 className="m-b-0">
                        <span>{list.length}</span>
                      </h2>
                    </div>
                    <div className="avatar avatar-icon avatar-lg avatar-red">
                      <i className="anticon anticon-bar-chart" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


          {/* end */}

          <div className="card">
            <div style={{ paddingTop: "10px", paddingLeft: "20px" }}>


              <div className='row' >

                <div className='col-3' >
                  <Autocomplete
                    disablePortal
                    id="size-small-standard"
                    size="small"
                    value={selected}
                    onChange={(event, newValue) => {
                      setSelected(newValue)
                      if (newValue === null) {

                      } else {
                        getfilter_Agent(newValue.name)


                      }

                    }}
                    options={agentList}
                    // sx={{ width: 100 }}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => (
                      <Box component="li"  {...props}>

                        {option.name}
                      </Box>
                    )}
                    renderInput={(params) => <TextField {...params} label="Agent Name" />}
                  />
                </div>
                <div className='col-3' >
                  {
                    listoldStatus ? <button style={{ margin: "10px" }} onClick={() => {
                      const a = listold;
                      setList(a)
                      setListoldStatus(false)
                      setSelected()


                    }} className="btn btn-success m-r-5">Reset</button> : ""
                  }
                </div>
              </div>
            </div>

            <div className="card-body">
              <div>
                <div id="data-table_wrapper" className="dataTables_wrapper ">

                  <div className="row">
                    <div className="col-sm-12">
                      <table
                        id="data-table"
                        className="table dataTable"
                        role="grid"
                        aria-describedby="data-table_info"
                      >
                        <thead>
                          <tr role="row">
                            <th className="sorting_asc">
                              ID
                            </th>
                            <th className="sorting_asc" >
                              Website
                            </th>
                            <th className="sorting_asc" >
                              Manager Res.
                            </th>
                            <th className="sorting_asc">
                              Date
                            </th>

                            <th className="sorting">
                              Agent Name
                            </th>
                            <th className="sorting">
                              Resp.
                            </th>
                            <th className="sorting">
                              Action
                            </th>

                          </tr>
                        </thead>
                        <tbody>
                          {
                            list.map((v, i) => (
                              <div key={i}>
                                <tr role="row" className="odd">
                                  <td>{v.inq} </td>
                                  <td
                                    style={{
                                      color: v.manager_response == "0" ? "#e63b60" : "green",
                                      fontWeight: v.manager_response == "0" ? "bold" : "normal",
                                    }}
                                  >
                                    {v.web}
                                  </td>
                                  <td style={{
                                    color: v.manager_response == "0" ? "#e63b60" : "green",
                                    fontWeight: v.manager_response == "0" ? "bold" : "normal",

                                  }} >
                                    {v.manager_response == "0" ? "Pending" : "Active"}
                                  </td>
                                  <td>
                                    <HtmlTooltip
                                      sx={{ borderRadius: 2, minWidth: 300, }}
                                      title={
                                        <div >
                                          <center>
                                            <div className='row'>
                                              <div className='col-12'>Email</div>
                                              <div className='col-12' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.email}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-12'>Phone</div>
                                              <div className='col-12' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.phone}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-12'>Adult / Child /Infant </div>
                                              <div className='col-12' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.adult} / {v.child} / {v.infant}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Name</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.name}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Dep</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.dep}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Arri</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.arri}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Date</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.date}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Mak</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.makkah}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Man</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.madina}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Type</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.type}</b></div>
                                            </div>

                                            <div className='row'>
                                              <div className='col-3'>Acc</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.acc}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Date</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.date_portal}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-3'>Time</div>
                                              <div className='col-9' style={{ color: "red", fontWeight: 'bold' }} ><b>{v.date_time}</b></div>
                                            </div>
                                            <div className='row'>
                                              <div className='col-12' style={{ color: "red", fontWeight: 'bold' }} ><a target="_blank" href={v.url}>{v.url}</a></div>
                                            </div>
                                          </center>
                                        </div>
                                      }
                                    >
                                      <Button>{v.date_portal}</Button>
                                    </HtmlTooltip>
                                  </td>
                                  <td>{v.agent_name} </td>
                                  <td>{v.response == "0" ? "-" : v.response} </td>
                                  <td><a href={"View_inquiry_manager?id=" + v.inq}>
                                    <button className="btn btn-warning m-r-5 ">{v.agent_status == "new" ? "Waiting Response" : getNamesByValue(status_list, v.agent_status)}</button>
                                  </a>
                                  </td>
                                </tr>
                              </div>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div >
            </div>
          </div>
        </div>
        {/* Content Wrapper END */}
        {/* Footer START */}
        <Footer />
        {/* Footer END */}
      </div>
    </>
  );
}